<template>
    <div class="mheaderBox" id="h_target" :class="{'fixed':isfixed}">
       <div class="logo">
			  <router-link :to="{ name: 'mhome' }">
                    <img :src="CompanyInfo.email" />
              </router-link>
		</div>
        <div class="mobile-inner-header-icon mobile-inner-header-icon-out" @click="shownav()">
            <span></span>
            <span></span>
            <span></span>
		</div>
        <div class="mobile-inner-nav">
            <div class="item"   @click="hidenav()">
                 <div class="level_1">
                    <router-link :to="{ name: 'mhome' }">{{$t('header.about')}}</router-link>
                 </div>
            </div>
             <div class="item"   @click="hidenav()">
                 <div class="level_1">
                   <router-link slot="reference" :to="{ name: 'product', params: { id: 1 } }">{{$t('header.product')}}</router-link>
                 </div>
                 <div class="level_2">
                    <template v-for="(item, index) in industry_list">
                      <router-link  :to="{ name: 'product', params: { id: item.id } }" :key="index">
                        <div class="name" v-if="currentLang=='zh'">{{ item.title }}</div>
                        <div class="name" v-else>{{ item.enTitle }}</div>
                      </router-link>
                    </template>
                 </div>
            </div>
            <div class="item"   @click="hidenav()">
                 <div class="level_1">
                    <router-link :to="{ name: 'esg' }">ESG</router-link>
                 </div>
            </div>
             <div class="item"   @click="hidenav()">
                 <div class="level_1">
                    <router-link :to="{ name: 'news' }">{{$t('header.news')}}</router-link>
                 </div>
            </div>
             <div class="item" v-if="!CompanyInfo.tel=='false'"  @click="hidenav()" >
                 <div class="level_1">
                    <router-link :to="{ name: 'join' }">{{$t('header.join')}}</router-link>
                 </div>
            </div>
             <div class="item"   @click="hidenav()">
                 <div class="level_1">
                    <router-link :to="{ name: 'contact' }">{{$t('header.contact')}}</router-link>
                 </div>
            </div>
        </div>
        <LangCom></LangCom>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import LangCom from './LangCom.vue'
import $ from 'jquery';
export default {
  data() {
    return {
       CompanyInfo: {},
      isfixed: false,
      targetTop: 0,
      industry_list: {},
      currentLang:this.$i18n.locale
    };
  },
  components: {
    LangCom,
  },
  mounted() {
      window.addEventListener("scroll", this.scrolling)
      this.targetTop = document.querySelector('#h_target').offsetTop
  },
  created: function () {
    this.GetInfo();
     this.GetCat();
  },
  methods: {
     ...mapActions([
      'setCategoryList',
      'setCompanyInfo'
    ]),
      shownav(){
			      $(".mobile-inner-nav").slideToggle(250);
      },
      hidenav(){
          $(".mobile-inner-nav").hide();
      },
       GetInfo() {
      var url = "/pageapi/common/GetCompanyInfo";
      this.$http.post(url, {}).then(
        function (res) {
          if (res.data.status == 1) {
            this.CompanyInfo = res.data.ds;
            this.setCompanyInfo(res.data.ds);

          }
        }.bind(this)
      )
        .catch(function (error) { });
    },
     GetCat() {
      var url = "/pageapi/Product/GetCat";
      this.$http.post(url, {}).then(function (res) {
        if (res.data.status == 1) {
          
          this.industry_list = res.data.ds;
          this.setCategoryList(res.data.ds);
        }
      }.bind(this)).catch(function () {
      });
    },
    scrolling() {
          let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          if (scrollTop > this.targetTop) {
              this.isfixed = true;
          } else {
              this.isfixed = false;
          }
      },
  }
};
</script>
<style>
.mheaderBox{
    background-color: rgba(255, 255, 255, 1);
    width: 100%;
    height: 6rem;
    top: 0px;
    left: 0px;
    box-shadow: 0px 7px 7px -7px #f6f6f6;
    z-index: 99;
}
.mheaderBox.fixed{
  position: fixed;
}
.mheaderBox .logo img{
    width: 9rem;
    position: relative;
    left: 2rem;
    top: 1rem;
}
.mobile-inner-header-icon{
    color: #ffffff;
    height:6rem;
    font-size: 25px;
    text-align: center;
    float: right;
    width:5rem;
    position: absolute;
    right: 6rem;
    top: 0;
    -webkit-transition: background 0.5s;
    -moz-transition: background 0.5s;
    -o-transition: background 0.5s;
    transition: background 0.5s;
}
.mobile-inner-header-icon span{
	position: absolute;
	left: calc((100% - 16px) / 2);
	top: calc((100% - 4px) / 2);
	width: 16px;
    height: 1.5px;
	background-color: rgba(51,51,51,1);
}
.mobile-inner-header-icon span:nth-child(1){
    transform: translateY(4) rotate(0deg);
}
.mobile-inner-header-icon span:nth-child(2){
    transform: translateY(-4px) rotate(0deg);
}

.mobile-inner-header-icon-click span:nth-child(1){
	animation-duration: 0.5s;
	animation-fill-mode: both;
	animation-name: clickfirst;
}		
.mobile-inner-header-icon-click span:nth-child(2){
	animation-duration: 0.5s;
	animation-fill-mode: both;
	animation-name: clicksecond;
}
.mobile-inner-header-icon-click span:nth-child(3){
	display: none;
}
@keyframes clickfirst {
  0% {
	  transform: translateY(4px) rotate(0deg);
	  
  }
  100% {
    transform: translateY(0) rotate(45deg);
  }
}	
@keyframes clicksecond {
  0% {
	  transform: translateY(-4px) rotate(0deg);
  }

  100% {
    transform: translateY(0) rotate(-45deg);
  }
}	
.mobile-inner-header-icon-out span:nth-child(1){
	animation-duration: 0.5s;
	animation-fill-mode: both;
	animation-name: outfirst;
	}		
.mobile-inner-header-icon-out span:nth-child(2){
	animation-duration: 0.5s;
	animation-fill-mode: both;
	animation-name: outsecond;
	}

@keyframes outfirst {
  0% {
    transform: translateY(0) rotate(-45deg);
  }

  100% {
    transform: translateY(-4px) rotate(0deg);
  }
}	
@keyframes outsecond {
  0% {
    transform: translateY(0) rotate(45deg);
  }

  100% {
    transform: translateY(4px) rotate(0deg);
  }
}
.mobile-inner-nav{
	background-color: rgba(255,255,2555,1);
	width: 100%;
	position: fixed;;
	top: 6.2rem;
	left: 0px;
    display: none;
    z-index: 99;
    overflow: scroll;
    max-height: 80%;
}
.mobile-inner-nav .item{
    border-bottom: 1px solid #f9f9f9;
    padding: 1.2rem 1.5rem;
}
.mobile-inner-nav .item .level_2{
    padding-top: .50rem;
    padding-left: 1rem;
}
.mobile-inner-nav .item .level_2  a{
    display: inline-block;
    padding-right: 2rem;
}
.mobile-inner-nav .item .level_2  a .name{
    color: #555;
    font-size: 1.2rem;
    position: relative;
    padding-left: 6px;
}
.mobile-inner-nav .item .level_2  a .name::after{
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -1.5px;
    width: 3px;
    height: 3px;
    background-color: #666;
    border-radius: 50%;
}
.mheaderBox  .lang {
    position: absolute;
    right: 1.5rem;
    top: 0;
    line-height: 5rem;
    font-size: 1.2rem;
    color: #c1c1c1;
    padding-top: .25rem;
}
.mheaderBox  .lang a{
    display:inline-block;
    color: #c1c1c1;
}
.mheaderBox  .lang a.curr{
  color: #666;
}
</style>